import React from 'react';

const ActivateFailed = ({ error, onActivate }) => {
    return (
        <React.Fragment>
            <h3>Publish Failed</h3>
            <p>{error}</p>
            <button className="btn btn-primary" onClick={onActivate}>Retry</button>
        </React.Fragment>
    );
};

export default ActivateFailed;
